import { CSSProperties, useState } from 'react';

import Loader from '~components/generic/loader/Loader';

type IframeProps = {
  src: string;
  minHeight?: number;
  style?: CSSProperties;
  allow?: string;
  onAutoResize?: () => void;
};

export const Iframe = ({ src, style = { width: '1px', minWidth: '100%' }, minHeight, allow }: IframeProps) => {
  const [loadingIframe, setLoadingIframe] = useState(true);

  return (
    <>
      <iframe
        src={src}
        style={style}
        width="100%"
        height={minHeight ?? 800}
        allow={allow}
        onLoad={() => setLoadingIframe(false)}
      ></iframe>
      {loadingIframe ? <Loader absoluteCenter={true} /> : null}
    </>
  );
};
